import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "../Layout";
import "./VerticalAdaptLayout.less";
import FillLayout from "../fill/FillLayout";

const CLASS_NAME = "fct-vertical-adapt-layout";
const HORIZONTAL_ALIGN = {
  STRETCH: "_stretch",
  LEFT: "_left",
  CENTER: "_center",
  RIGHT: "_right"
};

class VerticalAdaptLayout extends Component {
  static defaultProps = {
    restrict: true,
    scrolly: true,
    horizontalAlign: HORIZONTAL_ALIGN.LEFT
  };

  _renderNoRestrict() {
    const {
      children,
      restrict,
      horizontalAlign,
      className,
      ...props
    } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, horizontalAlign, className)} {...props}>
        {React.Children.map(children, child => {
          return (
            child &&
            React.cloneElement(child, {
              className:
                child.props.height > 0
                  ? cn("layout-item", child.props.className)
                  : cn("layout-item", "layout-full-item", child.props.className)
            })
          );
        })}
      </Layout>
    );
  }

  _renderRestrict() {
    const {
      children,
      restrict,
      horizontalAlign,
      scrolly,
      className,
      ...props
    } = this.props;
    let allHeight = 0;
    React.Children.forEach(children, child => {
      if (child) {
        allHeight += child.props.height || 0;
      }
    });
    return (
      <Layout
        className={cn(CLASS_NAME, horizontalAlign, className)}
        scrolly={false}
        {...props}
      >
        {React.Children.map(children, child => {
          return (
            child &&
            React.cloneElement(child, {
              ...(child.props.height > 0
                ? {}
                : {
                    style: {
                      ...child.props.style,
                      height: `calc(100% - ${allHeight}px)`
                    }
                  })
            })
          );
        })}
      </Layout>
    );
  }

  render() {
    return this.props.restrict
      ? this._renderRestrict()
      : this._renderNoRestrict();
  }
}

VerticalAdaptLayout.Item = FillLayout;
VerticalAdaptLayout.VERTICAL_ALIGN = HORIZONTAL_ALIGN;
export default VerticalAdaptLayout;



// WEBPACK FOOTER //
// ./layout/adapt/VerticalAdaptLayout.js